/*
    Made by : Samuel
    date :
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import styles from "./NotFound.module.css";

// ----------------------------------------------------------------------------- //
// PROPS //

// ----------------------------------------------------------------------------- //
// COMPONENT //

function NotFoundText() {
    return (
        <div className={styles.container}>
            <img
                src="/Unauthorized.png"
                alt="Not Found"
                className={styles.image}
            />
            <h1 className={styles.title}>Oops! Page Not Found</h1>
            <p className={styles.text}>
                The page you're looking for doesn't exist or has been moved.
            </p>
            <button
                className={styles.button}
                onClick={() => (window.location.href = "/")}>
                Go Back Home
            </button>
        </div>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default NotFoundText;

// ----------------------------------------------------------------------------- //
